
import { mapState } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import IconActionCards from "@/components/cta/IconActionCards.vue";
import { assetsUrl } from "@/env";

@Component({
  name: "BeforeStarting",
  tabs() {
    return this.beforeStartHelpTabs;
  },
  components: { IconActionCards },
  computed: {
    ...mapState(["beforeStartHelpTabs"]),
  },
})
export default class BeforeStarting extends Vue {
  generate_pdf_url(index): void {
    return `${assetsUrl}guides/${this.tutocards[index].pdf}`;
  }

  generate_docx_url(index): void {
    return `${assetsUrl}guides/${this.fichecards[index].ref}`;
  }

  data(): any {
    return {
      tabs: [],
      tab: [],
      consultation: false,
      currenttab: "preambule",
      tutocards: [
        {
          title: "Tutoriel 1 - Créer une activité",
          pdf: "1._Créer_une_activité_-_Tutoriel_ECC_IPE.pdf",
          flex: 6,
        },
        {
          title: "Tutoriel 2 - Créer une séquence",
          pdf: "2._Créer_une_séquence_-_Tutoriel_ECC_IPE.pdf",
          flex: 6,
        },
        {
          title: "Tutoriel 3 - Lancer une séquence",
          pdf: "3._Lancer_une_séquence_-_Tutoriel_ECC_IPE.pdf",
          flex: 6,
        },
      ],
      fichecards: [
        {
          title: "Fiche d'utilisation de la plateforme",
          subtitle: "À remplir lors de la réalisation d'une activité en classe",
          ref: "Fiche_d_utilisation_ecc_ipe.docx",
          flex: 6,
        },
        {
          title: "Fiche modèle création de tâche de transfert",
          subtitle:
            "À remplir pour la création d'une activité spécifique à une filière",
          ref: "Fiche_modèle_-_Création_tâche_de_transfert.docx",
          flex: 6,
        },
      ],
    };
  }

  mounted(): any {
    this.tabs = this.beforeStartHelpTabs;
  }

  changeSelected(tab): any {
    this.currenttab = tab;
    this.consultation = false;
  }

  consulter(index): void {
    console.log("--");
    let url = this.generate_pdf_url(index);
    console.log(url);
    document.getElementById("liseuse").src = url;
    this.consultation = true;
  }

  quitConsult(): void {
    this.consultation = false;
  }
}
